<app-login *ngIf="step === 'login'" (changeStep)="step = $event"></app-login>
<app-mantenedor *ngIf="step === 'mantenedor'" (changeStep)="step = $event"></app-mantenedor>